import {
	GET_POST_INPUT_JSON_SCHEMA,
	GET_POST_INPUT_SCHEMA,
	PUBLIC_POST_ERROR_MESSAGES,
} from './getPostContract'
import type { PublicRepostSnapshot } from './getRepostContract'

type GetRepostModelContext = Pick<WebMCP.ModelContext, 'registerTool'>
type FetchPublicRepost = (id: string, signal?: AbortSignal) => Promise<PublicRepostSnapshot>

let getRepostToolRegistration: Promise<void> | undefined

function createGetRepostTool(fetchPublicRepost: FetchPublicRepost): WebMCP.ModelContextTool {
	return {
		name: 'get_repost',
		title: '获取即刻转发动态',
		description:
			'Get a public Jike repost snapshot with its reference by ID for static activity page generation.',
		inputSchema: GET_POST_INPUT_JSON_SCHEMA,
		annotations: {
			readOnlyHint: true,
			untrustedContentHint: true,
		},
		// Chrome 151 omits callback options even though webmcp-types@0.1.5 marks them as required.
		execute: async (input, options?: WebMCP.ToolExecuteCallbackOptions) => {
			const result = GET_POST_INPUT_SCHEMA.safeParse(input)

			if (!result.success) {
				throw new Error(PUBLIC_POST_ERROR_MESSAGES.invalidId)
			}

			return fetchPublicRepost(result.data.id, options?.signal)
		},
	}
}

export function registerGetRepostTool(
	modelContext: GetRepostModelContext | undefined,
	fetchPublicRepost: FetchPublicRepost
): Promise<void> {
	if (!modelContext) {
		return Promise.resolve()
	}

	if (!getRepostToolRegistration) {
		getRepostToolRegistration = Promise.resolve()
			.then(() => modelContext.registerTool(createGetRepostTool(fetchPublicRepost)))
			.catch(() => {
				getRepostToolRegistration = undefined
			})
	}

	return getRepostToolRegistration
}
